window.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.querySelector('#lumin-sticky-atc');
  if (!stickyATC) return;

  const img = stickyATC.querySelector('.product-content img');
  const btn = stickyATC.querySelector('[name="add"]');
  const btnSpinner = btn?.querySelector?.('.loading-overlay__spinner');
  const selectField = stickyATC.querySelector('select[name="id"]');
  const mainAddButton = document.querySelector('button[name="add"]');

  if (!mainAddButton) return;

  const threshold = mainAddButton.getBoundingClientRect().bottom + Number(stickyATC.dataset.offset || 0);

  window.addEventListener('scroll', () => {
    if (window.scrollY > threshold) {
      stickyATC.classList.add('show');
      document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
      document.documentElement.style.height = 'auto';
    } else {
      stickyATC.classList.remove('show');
      document.documentElement.style.paddingBottom = '0';
    }
  });

  if (selectField && img) {
    selectField.addEventListener('change', () => {
      const selectedOption = selectField.options[selectField.selectedIndex];
      const newImage = selectedOption?.dataset?.img;
      if (newImage) img.setAttribute('src', newImage);
    });
  }

  document.querySelector('.product-form [name="id"]')?.addEventListener('change', (e) => {
    const value = Number(e.target.value);
    if (value && selectField) {
      selectField.value = value;
    }
  });
});
